import { render, staticRenderFns } from "./EventChart.vue?vue&type=template&id=e4a1cee2"
import script from "./EventChart.vue?vue&type=script&lang=ts"
export * from "./EventChart.vue?vue&type=script&lang=ts"
import style0 from "./EventChart.vue?vue&type=style&index=0&id=e4a1cee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports